import styled from 'styled-components';
import { global } from '../../../shared/colors';

const AlertText = styled.p`
    color: ${global.textGrey};
    margin-bottom: 40px;
`;

export default AlertText;
